import { Box, Card, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { parseAVHtmlData } from "../../../../utils/helpers";
import { ASSETS } from "../../../../utils/config";
import RemoveIcon from "@mui/icons-material/Remove";
import { colors } from "../../../../utils";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ClearIcon from "@mui/icons-material/Clear";

function SegmentContent({
  content,
  onClickNext = () => {},
  onClickPrev = () => {},
  disableNext = false,
  disablePrev = false,
  showLabels = false,
  onClose = () => {},
}) {
  const [fullPreview, setFullPreview] = useState(false);

  if (!content) {
    return null;
  }

  const updatedHTML = parseAVHtmlData(content[0]?.text_body);
  return (
    <>
      {fullPreview && showLabels && (
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          sx={{
            position: "absolute",
            top: 3,
            right: 10,
          }}
        >
          <ArrowCircleLeftOutlinedIcon
            style={{ fontSize: "30px", opacity: disablePrev ? 0.5 : 1 }}
            onClick={() => (disablePrev ? null : onClickPrev())}
          />
          <ArrowCircleRightOutlinedIcon
            style={{ fontSize: "30px", opacity: disableNext ? 0.5 : 1 }}
            onClick={() => (disableNext ? null : onClickNext())}
          />
        </Stack>
      )}
      <Card
        sx={{
          my: 1,
          width: fullPreview ? "97vw" : "95vw",
          height: fullPreview ? "85vh" : "45vh",
          backgroundColor: content[0]?.inner_color,
          p: 1.2,
          pt: 1,
          position: fullPreview ? "absolute" : "relative",
          top: fullPreview ? 30 : undefined, // Use undefined instead of false for CSS properties
          overflow: fullPreview ? "hidden" : undefined,
          border: `1px solid ${content[0]?.color}`,
          ml: "1.5vw",
          borderLeft: `10px solid ${content[0]?.color}`,
          mb: 3,
          scrollY: "auto",
          zIndex: fullPreview ? 1000 : undefined,
        }}
      >
        <Stack
          sx={{ mb: 1 }}
          justifyContent={"space-between"}
          direction={"row"}
        >
          <Typography
            sx={{
              color: "#123051",
              fontFamily: "DM Sans",
              fontWeight: "bold",
              fontSize: "14px",
              textTransform: "capitalize",
            }}
          >
            {content[0]?.title}
          </Typography>
          <Stack justifyContent={"space-between"} direction={"row"}>
            {fullPreview ? (
              <RemoveIcon
                onClick={() => setFullPreview(false)}
                size={10}
                style={{ fontSize: "25px", color: colors.primary }}
              />
            ) : (
              <img
                onClick={() => setFullPreview(true)}
                src={ASSETS.Content_Full_Preview}
                alt="preview"
                style={{ height: "25px", width: "25px" }}
              />
            )}
            <ClearIcon
              onClick={onClose}
              color={colors.primary}
              style={{
                fontSize: "28px",
                marginLeft: "5px",
              }}
            />
          </Stack>
        </Stack>

        <Stack sx={{ height: "100%" }} direction={"column"}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              backgroundColor: "white",
              borderRadius: 2,
              pb: 1,
              overflowY: "auto",
            }}
          >
            <div
              style={{ fontSize: 12, padding: 5 }}
              dangerouslySetInnerHTML={{ __html: updatedHTML }}
            />
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default SegmentContent;
